import { FC } from 'react';

import { ResponsiveCarousel } from 'components/responsive-carousel';

import { IncentiveCard } from '../loyalty-incentives-components/incentive-card/incentive-card';

import { RewardCategoryCarouselContainer } from './loyalty-rewards.styled';
import { EnrichedReward, ILoyaltyRewardsCategoryList } from './types';

export const LoyaltyRewardsCategoryCarousel: FC<ILoyaltyRewardsCategoryList> = ({
  rewards,
  locked,
  handleOnPress,
  inCooldown,
}) => {
  return (
    <RewardCategoryCarouselContainer>
      <ResponsiveCarousel
        loop={false}
        itemWidth={168}
        data={rewards}
        keyExtractor={item => (item as EnrichedReward).rewardId}
        renderItem={({ item }) => {
          const { rewardId, incentive, inlineAlertMessage, isApplied } = item as EnrichedReward;
          return incentive && rewardId ? (
            <IncentiveCard
              key={rewardId}
              incentive={incentive}
              handlePress={handleOnPress}
              locked={locked || false}
              inlineAlertMessage={inlineAlertMessage}
              isPictureBlurhashEnabled={false}
              isApplied={isApplied}
              inCooldown={inCooldown}
            />
          ) : null;
        }}
      />
    </RewardCategoryCarouselContainer>
  );
};
